import type {ProductDops, ProductPrices} from './types'

type Attribyte = {
    name:string
    value:string
    children: Array<Attribyte>
    price?:number
    price_id?:number
}

export default class Product {
    private _id:number
    private _name:string
    private _description:string
    private _short_description:string
    private _discount:number
    private _dops:Array<ProductDops> = []
    private _attributes:Array<Attribyte> = []
    


    constructor(id :number, receivedPrices :Array<ProductPrices>, name:string, description:string, discount:number, dops:Array<ProductDops>, short_description:string){
        this._id = id
        this._name = name
        this._description = description
        this._discount = discount
        this._dops = dops 
        this._short_description = short_description
        this.setAttributes(receivedPrices)
    }

    get name():string{
        return this._name
    }

    get id():number{
        return this._id
    }

    get description():string{
        return this._description
    }

    get discount():number{
        return this._discount
    }

    get dops():Array<ProductDops>{
        return this._dops
    }

    get attributes():Array<Attribyte> {
        return this._attributes
    }

    get short_description(){
        return this._short_description
    }
    setAttributes(receivedPrices :Array<ProductPrices>) {
        const variationsTree:Attribyte = {
            name: "",
            value: "",
            children: [],
        }

        for(const price of receivedPrices){
            let curNode:Attribyte = variationsTree
            const sortedAttributes = price.attributes
            sortedAttributes.sort((a, b) => a.name < b.name ? -1 : 1)

            for (const a of sortedAttributes) {
                const found = curNode.children.find(el => el.name == a.name && el.value == a.value)
                if (found == undefined) {
                    const next: Attribyte = {
                        name: a.name,
                        value: a.value,
                        children: [],
                    }
                    curNode.children.push(next)
                    curNode = next
                } else {
                    curNode = found
                }
            }
            curNode.price = price.price
            curNode.price_id = price.id
        }
        this._attributes = variationsTree.children
    }

}